export default "__VITE_ASSET__a3ec9cb0__"